import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Maryland Zaza · Cannabis Insights</p>
        <h1>Welcome to Maryland Zaza</h1>
        <p className="lede">
          Your go-to source for the latest news and information on cannabis policy and culture in Maryland. 
          Stay informed about local laws, legal status updates, and educational resources.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and policy in Maryland. 
            We provide timely coverage of new laws and regulations affecting the community.
          </p>
        </article>
        <article>
          <h2>Legal Status Information</h2>
          <p>
            Understand the current legal landscape of cannabis in Maryland. 
            Our comprehensive guides help you navigate the complexities of cannabis law.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Access a wealth of information about cannabis culture, health benefits, and responsible use. 
            Our educational resources aim to inform and empower the community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;